import moment from 'moment'
import numeral from 'numeral'

export default {
filters: {
    formatLongDate: function (value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY hh:mm')
            }
    },
    formatLongAndSecondDate: function (value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
            }
    },
    formatDate: function (value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY')
            }
    },
    formatNumber: function (value) {
        if (value) {
            return numeral(value).format('0,0')
        }

        return '0,0'
    },
    formatNumberDecial: function (value) {
        if (value) {
            return numeral(value).format('0,0.00')
        }

        return '0,0.00'
    },
    },
    methods: {
        booleanFormat (value) {
            return value ? this.$t('Yes') : this.$t('No')
          },
          formatLongCRDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
                }
        },
    },
}
